import { Box, Card, Switch, Typography } from "@material-ui/core";
import VisibleFor from "auth/components/VisibleFor";
import { Role } from "auth/types";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { getHistoryForSensor } from "safetySensors/Sensors.actions";
import { DeviceType } from "../../common/types";
import { INode } from "../../search/types";
import { ISensorData } from "../types";
import styles from "./SafetySensors.module.scss";
import { StatusIndicator } from "./statusIndicator";

export interface IRecievedProps {
  selectedNode?: INode;
  sensor?: ISensorData;
  onToggle: (checked: boolean) => void;
}

const SafetySensorButton = ({
  selectedNode,
  sensor,
  onToggle,
}: IRecievedProps) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const { domain }: any = useParams();
  const [alarm, setAlarm] = useState(false);
  const navigateToChosenSensor = () => {
    if (!selectedNode?.ID || !sensor?.MeasuringPointID) return;
    dispatch(
      getHistoryForSensor(domain, selectedNode.ID, sensor.MeasuringPointID)
    );
    history.push(
      `${domain ? `/${domain}` : ""}/safetySensorDetails/${selectedNode.ID}/${
        sensor.MeasuringPointID
      }`
    );
  };

  useEffect(() => {
    sensor?.Alert ? setAlarm(true) : setAlarm(false);
  }, [sensor]);

  return (
    <Card onClick={navigateToChosenSensor} className={styles.sensorDiv}>
      <Box
        className={
          !alarm ? styles.measuringPointName : styles.measuringPointNameWarn
        }
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h4">{sensor?.MeasuringPointName}</Typography>
        <VisibleFor
          roles={[Role.Tenant]}
          child={
            <Switch
              checked={!!sensor?.Monitoring}
              size="small"
              color="secondary"
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => onToggle(e.target.checked)}
            />
          }
        ></VisibleFor>
      </Box>
      <Box>
        {sensor?.DeviceType === DeviceType.Leakage && t("Leak detector")}
        {sensor?.DeviceType === DeviceType.Smoke && t("Fire alarm")}
      </Box>
      <StatusIndicator
        text={!alarm ? t("Everything OK") : sensor?.Alert?.Description}
        status={!alarm ? "ok" : "warning"}
      />
    </Card>
  );
};

export default SafetySensorButton;
